import React, { ChangeEvent, useEffect, useRef } from 'react';

export type FilesInputProps = {
  onMount: (ref: React.MutableRefObject<HTMLInputElement | null>) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const FilesInput = ({ onMount, onChange }) => {
  const ref = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      onMount(ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <input
      ref={ref}
      id='photo-add-input'
      type='file'
      multiple
      name="images"
      onChange={onChange}
      style={{ display: 'none' }} 
      accept="image/png, image/webp, image/jpeg"
      data-test-id="enhanced-scouting-files-input"
    />
  );
};
